import { useQuery } from '@tanstack/react-query';

import { socialApiClient } from '@/shared/api-client/social-api-client';

export type QueryStatus = {
  status: 'running' | 'completed' | 'failed';
  progress: number;
};

export function useCheckQueryStatus(workspaceId: string, queryId: string) {
  return useQuery({
    queryKey: ['query-status', workspaceId, queryId],
    queryFn: async () => {
      const response = await socialApiClient.get<QueryStatus>(
        `workspaces/${workspaceId}/queries/${queryId}/scraping_status`,
      );
      const data = await response.json();
      return data;
    },
  });
}
